import { Text } from '@change/ds-core-ui';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';
import { AfterMediaWaypoint } from 'src/app/pages/petitionDetails/shared/waypoints';

import { usePhoto } from '../hooks/photo';
import { useFirstMovement } from '../hooks/useFirstMovement';

import { MediaContainer } from './MediaSunrise';
import { MovementContainer } from './Movement';

export function HeadingContainerMobile(): JSX.Element {
	const photo = usePhoto();

	const firstMovement = useFirstMovement();
	const {
		data: { petition },
	} = usePetitionDetailsPageData();
	const title: string = petition.displayTitle;

	return (
		<div data-testid="heading-container-mobile">
			<div className="block [@media(min-width:768px)]:hidden">
				<div className="relative aspect-[10/11] h-full w-full overflow-hidden bg-black [@media(min-width:480px)]:aspect-[11/10]">
					<div className="w-full">
						{!!photo && <MediaContainer key={petition.id} photo={photo} />}
						<AfterMediaWaypoint />
						<div className="absolute inset-[20%] bottom-0 left-0 right-0 z-[10] h-[100%] w-full bg-[linear-gradient(to_top,rgba(0,0,0,1)_58%,rgba(0,0,0,1)_66%,rgba(0,0,0,0.8)_79%,rgba(0,0,0,0)_100%)]" />
						<div className="absolute bottom-0 left-0 right-0 z-[20] mb-[25px] px-8 py-[40px]">
							<div className="relative z-[25] flex flex-col items-start space-y-2">
								<div className="mb-4 h-[10.6px] w-[91.4px] bg-[#E5231E]" />
								<Text
									data-qa="petition-title"
									variant="heading"
									as="h2"
									size="x-large"
									className="max-w-[700px] text-balance text-xl font-bold leading-tight text-white"
								>
									{title}
								</Text>
							</div>
						</div>
						<div className="absolute bottom-[-7px] z-[13] h-[32px] w-full rounded-lg bg-white" />
					</div>
				</div>
			</div>

			{firstMovement && (
				<div className="mb-4 px-4 sm:mb-2 sm:px-0">
					<MovementContainer movement={firstMovement} alwaysExpanded={!photo} />
				</div>
			)}
		</div>
	);
}
